import React from 'react';

import ImportConnectionFilesModal from 'instruments/connection-files/ImportConnectionFilesModal';
import {ClientAutomationOutputFileConfigSpec} from 'lab-automation/settings/RunSchemaSpecConstants';

import * as SpreadsheetBulkImportActions from '../SpreadsheetBulkImportActions';
import {PaneKey} from '../SpreadsheetBulkImportConstants';

interface Props {
  nextPaneKey: PaneKey;
  adapterId?: string;
  delimiter: string;
  automationOutputFileConfig: ClientAutomationOutputFileConfigSpec;
  modalProps: {
    title: string;
    onRequestClose: () => void;
  };
  inferDataTypes?: boolean;
}

export default function ImportConnectionFilesModalPane(props: Props): JSX.Element {
  return (
    <ImportConnectionFilesModal
      adapterId={props.adapterId}
      onRequestSubmit={(connectionFiles) => {
        if (connectionFiles.length === 0) {
          return;
        }
        SpreadsheetBulkImportActions.uploadAndParseConnectionFiles(
          connectionFiles[0],
          props.adapterId,
          props.automationOutputFileConfig.transformDataType,
          props.delimiter,
          props.inferDataTypes
        );
        SpreadsheetBulkImportActions.goToPaneWithKey(props.nextPaneKey);
      }}
      allowMultiple={false}
      onRequestClose={props.modalProps.onRequestClose}
      automationOutputFileConfig={props.automationOutputFileConfig}
      showLineageParentFilter={true}
    />
  );
}
